import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    number: '01',
    title: 'Cruza tus piezas',
    desc: 'El domingo eliges qué proteína va con qué base en tu tablero.'
  }, {
    number: '02',
    title: 'Prepara el Alivio',
    desc: 'Dedicas 20 minutos a dejar tus componentes listos en la nevera.'
  }, {
    number: '03',
    title: 'Ensambla y Disfruta',
    desc: 'Al llegar a casa, abres la nevera, juntas tus piezas y cenamos. Sin preguntas.'
  }];
  return <section className="py-20 md:py-28 px-4 bg-cream" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-128">
          <p className="text-sm font-medium text-sage-dark tracking-widest uppercase mb-4" data-id="element-129">
            Cómo funciona
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-warm-900 leading-tight" data-id="element-130">
            Tres pasos. Una vez por semana.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative" data-id="element-131">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-sage/20 z-0" data-id="element-132" />

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="text-center relative z-10" data-id="element-133">
              <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-white border border-sage/20 flex items-center justify-center shadow-sm" data-id="element-134">
                <span className="font-heading text-3xl font-bold text-sage-dark" data-id="element-135">
                  {step.number}
                </span>
              </div>
              <h3 className="text-2xl font-heading font-semibold mb-3 text-warm-900" data-id="element-136">
                {step.title}
              </h3>
              <p className="text-warm-800/75 leading-relaxed max-w-xs mx-auto" data-id="element-137">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}